import React from 'react'
import {pathParams} from '../util'
import {isArray, union} from 'lodash'

const rollupPaths = (props, parentPath) => {
  if (!props.path && !props.primary && !props.default) {
    return []
  }
  let path = props.path || parentPath
  let children = []
  if (props.children) {
    children = isArray(props.children) ? props.children : [props.children]
  }
  const paths = []
  if (parentPath && path !== parentPath) {
    path = `${parentPath}/${path}`
    paths.push(path)
  }
  children.forEach((child) => {
    if (child.props.path || child.props.primary) {
      rollupPaths(child.props, path).forEach((p) => paths.push(p))
    }
  })
  return paths
}

const withChildPathProps = (Component, options = {}) => {
  const {
    additionPaths = [],
    parentPath = ''
  } = options
  return (props) => {
    if (!props.location) {
      return (<Component {...props}/>)
    }
    const paths = union(rollupPaths(props, parentPath), additionPaths)
    const params = pathParams(paths, window.location.pathname)
    props = {...props, ...params, paths}
    return (<Component {...props}/>)
  }
}

export {withChildPathProps, rollupPaths}

export default withChildPathProps